export const apiVersion = {
  version: '/api/v1'
}

export const endpoints = {
  supervisors: '/supervisors',
  addSupervisor : '/supervisors/create',
  crewEmployees: '/employee',
  ambulance: '/ambulance',
  all: '/all',
  parkingBay: '/parking-bay-locations',
  login: '/login',
  districts: '/districts/',
  zones: '/zones',
  states: '/states/',
  divisions: '/divisions/',
  tehsils: '/tehsils/',
  cityVillage: '/city-villages/',
  ambulanceEmployeeMapping: '/mapping',
  ambulanceEmployeeMappingAssign: '/assign',
  ambulanceParkingbayMapping: '/ambulance-parking-bay',
  ambulanceShiftMapping: '/ambulance-shift-mapping',
  register: '/register',
  photoDetails: '/photo',
  attendance: '/attendance',
  reportApi: '/report',
  downloadAttendance: '/downloadAttendanceCsv',
  template: '/template',
  import: '/import',
  bulk: '/bulk',
  download: '/download',
  tenants: '/tenants'
}